module.exports = __webpack_public_path__ + "1db2d364aa6eb59a087cb4f88966413b.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/csvdata/csvdatawidgetexample.png
// module id = 802
// module chunks = 7